import { z } from 'zod';

export const setLockedSchema = z.object({
  isLocked: z.boolean(),
});

export type SetLockedInput = z.infer<typeof setLockedSchema>;
